import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const UPGRADE_PAGE_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.CARSBooster,
  PlatformSlug.GREBooster,
  PlatformSlug.DLOSCE
)

export const REAL_STUDENT_REVIEWS_CONFIG = enabledOn(PlatformSlug.CARSBooster)

export const isUpgradePageAvailable = (slug?: PlatformSlug) => isFeatureAvailable(UPGRADE_PAGE_CONFIG, slug)
export const isRealStudentReviewsAvailable = (slug?: PlatformSlug) =>
  isFeatureAvailable(REAL_STUDENT_REVIEWS_CONFIG, slug)
